export default "__VITE_ASSET__a81ddfe8__"